import { useSelector } from "react-redux";

import user from "core/user";
import { Role } from "enums";

export const useHasRole: (roleToCheck: Role) => boolean = (roleToCheck: Role) => {
    const { roles } = useSelector(user.getUserAccount);
    return roles?.includes(roleToCheck);
};
